import { Table } from 'antd';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'types/store';
import { hospital_visit_and_links_results } from 'types';

type Props = {
  dataUpdate: hospital_visit_and_links_results[];
  onChangeData: any;
};

const TableReceive: FC<Props> = ({ dataUpdate, onChangeData }) => {
  const { hospitals, fieldHospital, field_edit, invoiceH } = useSelector((state: RootState) => state.receivingSlice);

  const hospitalVisitOption = useMemo(() => {
    const result = fieldHospital?.find(([_key, value]: [string, any]) => value.display_id === 'hospital_visit');
    if (!result) {
      return [];
    }
    return result[1].options;
  }, [fieldHospital]);

  const checkUpdate = (hospitalVisit: string) => {
    const statusEdit = field_edit.find((f: any) => f.value === invoiceH?.editing_status_by_clinic);
    const statusEditCheck = statusEdit ? statusEdit.display_id : invoiceH?.editing_status_by_clinic;
    if (
      invoiceH?.Status === '請求書作成中' &&
      statusEditCheck === 'o_editing' &&
      hospitalVisit !== 'o_advance_payment'
    ) {
      return true;
    }
    return false;
  };

  const checkHospitalVisit = (text: string, options: any[]) => {
    const find = options.find((f) => f.value === text);

    if (find) {
      return find.display_id;
    }
    return '';
  };

  const columns: any = [
    {
      title: '',
      width: '5%',
      key: 'index',
      align: 'center',
      render(text: string, row: any, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center', padding: '8px' },
            className: 'standardFont',
          },
          children: <div>{index + 1}</div>,
        };
      },
    },
    {
      title: 'ID',
      dataIndex: 'patient_id',
      key: 'patient_id',
      width: '25%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'center', padding: '8px' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: 'ご利用者名',
      dataIndex: 'patient_name',
      key: 'patient_name',
      width: '50%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center', padding: '8px' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '受診 XO',
      dataIndex: 'hospital_visit',
      key: 'hospital_visit',
      width: '20%',
      align: 'center',
      render(text: string, row: hospital_visit_and_links_results, index: number) {
        const d_update = dataUpdate.find((f) => f.i_id === row.i_id);

        const hospitalFirst = checkHospitalVisit(text, hospitalVisitOption);
        const checkOn = d_update ? d_update.hospital_visit : hospitalFirst;
        const isUpdate = checkUpdate(text);
        return {
          props: {
            style: { textAlign: 'center', padding: '8px' },
            className: 'standardFont',
          },

          children: (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                width: '100px',
                margin: '0px auto',
                opacity: isUpdate ? 1 : 0.5,
              }}
            >
              <svg
                onClick={() => onChangeData(row, 'o_yes', isUpdate)}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill={checkOn === 'o_yes' ? 'black' : '#D8D8D8'}
                />
              </svg>
              <div style={{ position: 'relative' }}>
                <svg
                  onClick={() => onChangeData(row, 'o_no', isUpdate)}
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.1875"
                    y="3.1687"
                    width="4.4812"
                    height="26.8872"
                    transform="rotate(-45 0.1875 3.1687)"
                    fill={checkOn === 'o_no' ? 'black' : '#D8D8D8'}
                  />
                </svg>
                <svg
                  style={{ position: 'absolute', left: 0 }}
                  onClick={() => onChangeData(row, 'o_no', isUpdate)}
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="19.0117"
                    width="4.4812"
                    height="26.8872"
                    transform="rotate(45 19.0117 0)"
                    fill={checkOn === 'o_no' ? 'black' : '#D8D8D8'}
                  />
                </svg>
              </div>
            </div>
          ),
        };
      },
    },
  ];

  return (
    <div>
      <Table columns={columns} dataSource={hospitals.items} pagination={false} />
    </div>
  );
};

export default TableReceive;
